import PropTypes from 'prop-types';
import { Provider, ErrorBoundary } from '@rollbar/react';
import { getProd } from '@figure/frontlib-onboarding-redux';

const Rollbar = ({ children }) => {
  const rollbarConfig = {
    accessToken: process.env.REACT_APP_ROLLBAR_ACCESS_TOKEN,
    captureUncaught: true,
    captureUnhandledRejections: true,
    enabled: getProd(),
    payload: {
      environment:
        window.location.hostname.indexOf('test.figure.com') > -1 ? 'development' : 'production',
      client: {
        javascript: {
          source_map_enabled: true,
          code_version: '%REACT_APP_GIT_SHA%',
        },
      },
    },
    uncaughtErrorLevel: 'warning',
  };

  return (
    <Provider config={rollbarConfig}>
      <ErrorBoundary>{children}</ErrorBoundary>
    </Provider>
  );
};

Rollbar.propTypes = { children: PropTypes.node.isRequired };

export default Rollbar;
